/**
 * Filters out deleted/orphaned custom fields from table field configurations.
 *
 * A custom field is considered deleted when its CustomFieldTemplate no longer
 * exists. In that case, useProjectSpecificFields cannot resolve a label for it,
 * so the field ends up with id "customFieldXXX" and a falsy label.
 *
 * Standard (non-custom) fields always have labels from the default config,
 * so this check is safe to apply only to custom fields.
 *
 * @param {Array} fields - Array of field objects with id, label, etc.
 * @returns {Array} Filtered array with deleted custom fields removed.
 */
export function filterDeletedCustomFields(fields) {
  if (!fields) return [];

  return fields.filter(field => {
    if (!field.id || !field.id.toString().startsWith("customField")) {
      return true;
    }

    // Active custom fields always have a label assigned by useProjectSpecificFields.
    // Deleted/orphaned ones do not.
    return !!field.label;
  });
}
